<div class="tabs-container">
    <tabs (tabClicked)="onTabClicked($event)">
        <tab title="Not Submitted">
            <ag-grid-angular class="data-grid " [gridOptions]="notSubmittedGridOptions" [rowData]="notSubmittedData"  [attr.aria-label]="widgetTitle + ' - Not Submitted'"></ag-grid-angular>
        </tab>
        <tab title="Action Needed">
            <ag-grid-angular class="data-grid " [gridOptions]="actionNeededGridOptions" [rowData]="actionNeededData"  [attr.aria-label]="widgetTitle + ' - Action Needed'"></ag-grid-angular>
        </tab>
        <tab title="Pending">
            <ag-grid-angular class="data-grid " [gridOptions]="pendingGridOptions" [rowData]="pendingData"  [attr.aria-label]="widgetTitle + ' - Pending'"></ag-grid-angular>
        </tab>
        <tab title="Incomplete">
            <ag-grid-angular class="data-grid " [gridOptions]="incompleteGridOptions" [rowData]="incompleteData"  [attr.aria-label]="widgetTitle + ' - Incomplete'"></ag-grid-angular>
        </tab>
        <tab title="Denied">
            <ag-grid-angular class="data-grid " [gridOptions]="deniedGridOptions" [rowData]="deniedData"  [attr.aria-label]="widgetTitle + ' - Denied'"></ag-grid-angular>
        </tab>
        <tab title="Approved">
            <ag-grid-angular class="data-grid " [gridOptions]="approvedGridOptions" [rowData]="approvedData"  [attr.aria-label]="widgetTitle + ' - Approved'"></ag-grid-angular>
        </tab>
    </tabs>
</div>




